import { Injectable } from '@angular/core';
import { SelectableDataCategoryGroup } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableDataCategory } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableData } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableDataCategoryFilter } from 'app/modules/main/components/data-selector/data-selector.models';
import { Offer } from 'app/modules/main/models/offers';
import { OfferType } from 'app/modules/main/models/offers';
import { of } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OfferTypeFilter implements SelectableDataCategoryFilter<Offer, OfferType> {

  private readonly promotionCategoryLabel = $localize`:@@communication-centre.advertiser.offer-selector.filter.category.promotion:Promotion`;
  private readonly voucherCategoryLabel = $localize`:@@communication-centre.advertiser.offer-selector.filter.category.voucher:Voucher`;

  private selectedCategory: SelectableDataCategory<OfferType>;

  readonly groups: Observable<SelectableDataCategoryGroup<OfferType>[]> =
    of([{
      categories:
        Object.values(OfferType)
          .map((offerType: OfferType) => {
            return { id: offerType, label: this.localizeLabel(offerType), value: offerType };
          })
    }]);

  clear(): Observable<void> {

    this.selectedCategory = undefined;

    return of(null);
  }

  select(
    selectedCategory: SelectableDataCategory<OfferType>
  ): Observable<void> {

    this.selectedCategory = selectedCategory;

    return of(null);
  }

  isMatch(
    selectableOffer: SelectableData<Offer>
  ): boolean {

    if (this.selectedCategory === undefined) {
      return true;
    }

    return (selectableOffer.data.type === this.selectedCategory.value);
  }

  private localizeLabel(
    label: string
  ): string {

    switch (label) {

      case 'promotion':
        return this.promotionCategoryLabel;

      case 'voucher':
        return this.voucherCategoryLabel;

      default:
        return label;

    }
  }

}
